import { bl_del_job_attachment_RowClass, bl_del_job_attachment_RowInterface } from '../../../../dbschema';
import { BaseContainerModel } from '../../../base-container.model';

export class JobAttachmentContainerModel extends BaseContainerModel {
  bl_del_job_attachment: bl_del_job_attachment_RowInterface = new bl_del_job_attachment_RowClass();
}